import { useCurrency } from "../../context/CurrencyContext";
import { formatPriceSync } from "../../utils/currency";

export default function PriceSummary({ priceBreakdown, currency, onBook, loading }) {
  const { currency: ctxCurrency } = useCurrency();
  const curr = currency || ctxCurrency;
  const total = priceBreakdown?.total ?? 0;

  return (
    <div className="border-t border-gray-200 pt-4 mt-4">
      <div className="flex justify-between items-center mb-4">
        <span className="font-bold text-gray-900">Total</span>
        <span className="text-xl font-bold text-[#222222]">{formatPriceSync(total, curr)}</span>
      </div>
      <button
        type="button"
        onClick={onBook}
        disabled={loading || total <= 0}
        className="w-full py-3 rounded-xl font-semibold text-white transition-all hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
        style={{ backgroundColor: "#1ABCE3" }}
      >
        {loading ? "Processing..." : "Book Now"}
      </button>
    </div>
  );
}
